var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CheckboxSelect"},_vm._l((_vm.tags),function(tag){return _c('div',{key:tag.item,staticClass:"CheckboxSelect-item",class:[
      _vm.classType,
      _vm.newValue.some(value => value === tag.value)
        ? 'CheckboxSelect-item-is-selected'
        : ''
    ],on:{"click":function($event){$event.stopPropagation();return _vm.changeValue(tag)}}},[_c('BSCCheckbox',{staticClass:"CheckboxSelect-checkbox",attrs:{"type":_vm.type,"value":_vm.newValue.some(value => value === tag.value)},on:{"input":function($event){return _vm.changeValue(tag)}},nativeOn:{"click":function($event){$event.preventDefault();}}}),_c('span',{staticClass:"CheckboxSelect-span"},[_vm._v(_vm._s(tag.label))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }